// extracted by mini-css-extract-plugin
export default {"actionsList":"main_actionsList__gYMev"};